"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var helper_toolkit_ts_1 = require("helper-toolkit-ts");
var MapView_1 = __importDefault(require("./MapView"));
var __1 = require("../");
var AppConfig_1 = require("../../AppConfig");
var WebmapId = AppConfig_1.MapConfig.WebmapId;
var MapViewContainer = function () {
    var saveMapCenterLocationInUrl = function (location) {
        var mapCenterLocation = AppConfig_1.SearchParamKeys.mapCenterLocation;
        var lon = location.lon, lat = location.lat, zoom = location.zoom;
        helper_toolkit_ts_1.urlFns.updateQueryParam({
            key: mapCenterLocation,
            value: lon + "," + lat + "," + zoom
        });
    };
    var parseMapCenterLocationFromUrl = function () {
        var mapCenterLocation = AppConfig_1.SearchParamKeys.mapCenterLocation;
        var searchParams = helper_toolkit_ts_1.urlFns.parseQuery();
        var values = searchParams[mapCenterLocation]
            ? searchParams[mapCenterLocation]
                .split(',')
                .map(function (d) { return +d; })
            : [];
        var lon = values[0], lat = values[1], zoom = values[2];
        return {
            lon: lon,
            lat: lat,
            zoom: zoom
        };
    };
    return (React.createElement(MapView_1.default, { webmapId: WebmapId, padding: { right: AppConfig_1.UIConfig.SidebarWidth }, initialMapCenterLocation: parseMapCenterLocationFromUrl(), onStationary: saveMapCenterLocationInUrl },
        React.createElement(__1.SmokeLayer, null),
        React.createElement(__1.WildfireLayer, null)));
};
exports.default = MapViewContainer;
